<script setup>
import {defineProps} from "vue";

const props =defineProps({ contactInfos: null });
const socialLinks =  props.contactInfos?.socialLinks??[]
console.log(socialLinks);
</script>

<template>
  <div class="uk-grid">
    <!-- header phone -->
    <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s">
      <div class="impx-top-phone">
        <p><i class="fa fa-phone"></i> Télephone : {{props.contactInfos?.contact}}</p>
      </div>
    </div><!-- header phone end-->
    <!-- header social media -->
    <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s">
      <div class="impx-top-social impx-text-white">
        <ul>
          <li :key="index" v-for="(item, index) in socialLinks"><a :href="item.url"><i :class="item?.icon"></i>{{item?.title??''}}</a></li>
        </ul>
      </div>
    </div>
    <!-- header social media end -->
  </div>

</template>

<style scoped>

</style>